import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  alerts: [],
  alertDetails: null,
  alertsFromInflux: [],
  sentAlienVaultEmail: {},
  filteredAlertsFromInflux: [],
  isLoading: false,
  error: null,
  commentFromInflux: [],
};

const alienVaultSlice = createSlice({
  name: 'alienVault',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAlerts: (state, action) => {
      state.alerts = action.payload;
      state.isLoading = false;
    },
    setSendAlienVaultEmail: (state, action) => {
      state.sentAlienVaultEmail = action.payload;
      state.isLoading = false;
    },
    setAlertDetails: (state, action) => {
      state.alertDetails = action.payload;
      state.isLoading = false;
    },
    setAlertsFromInflux: (state, action) => {
      state.alertsFromInflux = action.payload;
      state.isLoading = false;
    },
    setCommentFromInflux: (state, action) => {
      state.commentFromInflux = action.payload;
      state.isLoading = false;
    },
    setFilteredAlertsFromInflux: (state, action) => {
      state.filteredAlertsFromInflux = action.payload;
      state.isLoading = false;
    },
    setResetALienVault: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAlerts,
  setAlertDetails,
  setAlertsFromInflux,
  setCommentFromInflux,
  setSendAlienVaultEmail,
  setFilteredAlertsFromInflux,
  setResetALienVault,
} = alienVaultSlice.actions;

export default alienVaultSlice.reducer;
